export default "__VITE_ASSET__DyP6MRi9__"